var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"carta-iframe"}},_vm._l((_vm.images),function(img,index){return _c('img',{key:'images' + index,staticClass:"image-carta",attrs:{"src":img.image,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }